module.exports = __webpack_public_path__ + "img/bsAttrCard_icon_04.d2c3c84f.png";